import {useEffect, useState} from 'react'
import axios from 'axios'

type ResolutionMap = Record<string, string>

const RESOLUTION_ORDER = ['optimizedUrl', 'base']

export const useBestResolutionUrl = (urls: ResolutionMap | null) => {
    const [bestUrl, setBestUrl] = useState<string | null>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!urls || bestUrl) return

        let isCancelled = false

        const tryUrls = async () => {
            setLoading(true)
            for (const resolution of RESOLUTION_ORDER) {
                const url = urls[resolution]
                if (!url) continue
                if (url.includes('blob:')) {
                    setBestUrl(url)
                    return
                }
                try {
                    const response = await axios.head(url)
                    if (response.status >= 200 && response.status < 300 && !isCancelled) {
                        console.log(`Using ${resolution} resolution: ${url}`)
                        setBestUrl(url)
                        setLoading(false)
                        return
                    }
                } catch (e) {
                    // silently fail and try next
                }
            }

            if (!isCancelled) {
                setLoading(false)
            }
        }

        tryUrls()

        return () => {
            isCancelled = true
        }
    }, [urls])

    return {url: bestUrl, loading}
}
